import React, { PropTypes } from 'react';
import classNames from 'classnames';
import IconSVG from 'svg-inline-react';
import PureRenderMixin from 'react-addons-pure-render-mixin';

import './NoticeControl.scss';

var NoticeTypes = ['default', 'success', 'info', 'warning', 'danger'];
var NoticeAlign = ['left', 'right', 'center'];

/*
 Примеры:
 <Notice type="info" align="right" visible={ this.state.visible }>Уведомление</Notice>
 <Notice type="success" align="center"><button>Кнопка</button></Notice>
 <Notice>Примечание</Notice>
 */

class Notice extends React.Component {

    static propTypes = {
        className: PropTypes.string,
        visible: PropTypes.bool,
        type: React.PropTypes.oneOf(NoticeTypes),
        align: React.PropTypes.string
    };

    static defaultProps = {
        visible: true,
        type: 'default',
        align: 'left'
    };

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        var classes = classNames('Notice',
            this.props.className, {
                'notice--visible': Boolean(this.props.type)
            },
            `notice--${this.props.type}`,
            `notice--align-${this.props.align}`
        );

        return (
            <div className={ classes }>
                <div className="Notice-lamp">
                    <IconSVG className="Notice-lampIcon"
                             src={require('!svg-inline!./lamp.svg')} />
                </div>
                <div className="Notice-content">
                    { this.props.children }
                </div>
            </div>
        );
    }

}

export default Notice;



// WEBPACK FOOTER //
// ./client/components/NoticeControl/NoticeControl.js